import { DefaultTheme } from 'styled-components'

export const theme: DefaultTheme = {
  colors: {
    black: '#1E293B',
    lightBlack: '#293445',
    gray: '#E4E5E7',
    white: '#FAFAFA',
    primary: '#1FC8E1',
    primaryDark: '#18A1B5',
  },
}
